<template>
  <div class="mt-3 pb-3 card shadow-sm">
    <p class="card-header float-left">得点率</p>
      <horizontal-bar-chart
        :chartData="chartData" :optionData="optionData" :height="250"/>
  </div>
</template>

<script>
import func from '@/lib/func';
import HorizontalBarChart from '@/components/atoms/HorizontalBarChart';

export default {
  name: 'rally-times-on-score',
  components: {
    HorizontalBarChart,
  },
  props: ['points', 'gameInfo'],
  computed: {
    rate() {
      const sum = func.sumArr(this.points);
      const player1 = func.round2(sum / this.points.length);
      const player2 = func.round2(1 - player1);
      return { player1, player2 };
    },
    chartData() {
      return {
        labels: ['得点率'],
        datasets: [
          {
            label: this.gameInfo.player1Name,
            backgroundColor: '#82B8D7',
            data: [this.rate.player1],
          },
          {
            label: this.gameInfo.player2Name,
            backgroundColor: '#83D7BD',
            data: [this.rate.player2],
          },
        ],
      };
    },
    optionData() {
      return {
        responsive: true,
        maintainAspectRatio: false,
        scales: {
          xAxes: [{
            stacked: true,
            ticks: {
              beginAtZero: true,
              min: 0,
            },
          }],
          yAxes: [{
            stacked: true,
          }],
        },
      };
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/molecules/ScoreRateOnSelectPoint.vue